var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable } from 'mobx';
import { safeReaction } from '../../common';
import { toHeaderSegment } from '../../utils';
import { handleClickOrHover, handleOnToggle } from '../HeaderNavItemEvents';
import { mapMenuItemsToNavItems } from '../HeaderNavItemHelper';
export default class NavItemStore {
    constructor(rootStore) {
        Object.defineProperty(this, "navItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "secondaryNavItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setNavItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (items = [], initialItems = false) => {
                this.setItems('navItems', items, initialItems);
            }
        });
        Object.defineProperty(this, "setSecondaryNavItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (items = [], initialItems = false) => {
                this.setItems('secondaryNavItems', items, initialItems);
            }
        });
        Object.defineProperty(this, "setItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (state, items = [], initialItems = false) => {
                let openItem;
                if (initialItems) {
                    openItem = this[state].find((item) => item.isOpen);
                }
                this[state] = items;
                if (openItem) {
                    this[state].forEach((item) => {
                        if (item.id === openItem.id) {
                            item.isOpen = true;
                        }
                    });
                }
            }
        });
        Object.defineProperty(this, "getNavItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { menuItems = [], frontlineMenuItems } = this.rootStore.menuItemStore;
                const { app } = this.rootStore.environmentStore;
                let mainMenuItems = menuItems.filter((item) => !item.divider);
                if (app === 'frontline' && frontlineMenuItems) {
                    mainMenuItems = frontlineMenuItems;
                }
                return this.mapMenuItems(mainMenuItems);
            }
        });
        Object.defineProperty(this, "getSecondaryNavItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { menuItems = [] } = this.rootStore.menuItemStore;
                const itemsWithDivider = menuItems.filter((item) => item.divider);
                return this.mapMenuItems(itemsWithDivider);
            }
        });
        Object.defineProperty(this, "getProfileTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { profileTypes } = this.rootStore.profileTypeStore;
                const types = profileTypes ? profileTypes.slice() : null;
                if (types && !types.includes('all')) {
                    types.push('all');
                }
                return types;
            }
        });
        Object.defineProperty(this, "mapMenuItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (items) => {
                const { currentPath, segment, setLocation } = this.rootStore.locationStore;
                const { slug } = this.rootStore.menuItemStore;
                const { authData, setLoginCallback } = this.rootStore.ssoStore;
                const { setSection } = this.rootStore.sectionStore;
                const { app, URLData } = this.rootStore.environmentStore;
                const { unpaidBill } = this.rootStore.billStore;
                const handleClick = (event, menuItem) => {
                    handleClickOrHover(event, menuItem, authData.isLoggedIn, setSection, setLoginCallback, setLocation);
                };
                return mapMenuItemsToNavItems({
                    menuItems: items,
                    currentPath,
                    slug,
                    loggedIn: authData.isLoggedIn,
                    urlData: URLData,
                    onClick: handleClick,
                    onToggle: handleOnToggle,
                    app,
                    profileTypes: this.getProfileTypes(),
                    headerSegment: toHeaderSegment(segment, app !== 'public'),
                    customerType: authData.customerType,
                    unpaidBill
                });
            }
        });
        Object.defineProperty(this, "initNavItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setNavItems(this.getNavItems(), true);
                this.setSecondaryNavItems(this.getSecondaryNavItems(), true);
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.initNavItems();
        safeReaction(rootStore, () => this.shouldUpdateNavItems, () => this.initNavItems());
    }
    get shouldUpdateNavItems() {
        return `${JSON.stringify(this.rootStore.menuItemStore.menuItems)}
    ${JSON.stringify(this.rootStore.menuItemStore.frontlineMenuItems)}
    ${this.rootStore.ssoStore.authData.isLoggedIn}
    ${this.rootStore.billStore.unpaidBill.sum}
    ${this.rootStore.locationStore.currentPath}
    ${this.rootStore.profileTypeStore.profileTypes}`;
    }
}
__decorate([
    observable.shallow
], NavItemStore.prototype, "navItems", void 0);
__decorate([
    observable.shallow
], NavItemStore.prototype, "secondaryNavItems", void 0);
__decorate([
    action
], NavItemStore.prototype, "setNavItems", void 0);
__decorate([
    action
], NavItemStore.prototype, "setSecondaryNavItems", void 0);
__decorate([
    action
], NavItemStore.prototype, "setItems", void 0);
__decorate([
    computed
], NavItemStore.prototype, "shouldUpdateNavItems", null);
//# sourceMappingURL=NavItemStore.js.map